// extracted by mini-css-extract-plugin
export default {"lock":"SuspendedLock_lock__I7cTb"};